// @flow
import request from 'superagent'
import { findPath } from '../reducers/select_framework_bar'
import * as types from '../constants/action_types'
import type { FrameworkType } from '../components/frameworks'
import type { BookmarkType } from '../reducers/select_bookmark_bar'

const updateGlobalBookmarks = (globalBookmarks: BookmarkType[]) => {
    request.post('/er2_ficus/updateBookmarks/')
        .send({ bookmarks: globalBookmarks.map(b => b.ficusNode) })
        .then((ret) => {
            // eslint-disable-next-line
            console.log(ret)
        })
}

/**
 * Flag any bookmarks that do not appear in the current list of frameworks
 * @param ficusNodes
 * @param frameworks
 */
export function processBookmarks(ficusNodes: string[], frameworks: FrameworkType[]) {
    const ret = []
    ficusNodes.forEach((bookmarkItem) => {
        let error
        // Original bookmark data was not an object but a string. Eventually this test can go away.
        const bookmarkData = { ficusNode: bookmarkItem.ficusNode || bookmarkItem }
        if (frameworks && frameworks.length) {
            const ficusPath = findPath(bookmarkData.ficusNode, frameworks)
            if (!ficusPath) {
                error = 'Bookmark not found'
            }
        }
        if (error) bookmarkData.error = error
        ret.push(bookmarkData)
    })
    return ret
}

export const addBookmark = (bookmarkType: string, ficusNode: string) => (dispatch: Function, getState: Function) => {
    dispatch({ type: types.ADD_BOOKMARK, bookmarkType, ficusNode })

    if (bookmarkType === 'bookmarksMRU') {
        // Limit history
        let bookmarksMRU = getState().selectBookmarkBar.bookmarksMRU
        const historyCount = getState().settingsBar.historyCount
        bookmarksMRU = bookmarksMRU.slice(0, historyCount)
        dispatch({ type: types.ADD_BOOKMARKS, bookmarkType: 'bookmarksMRU', bookmarks: bookmarksMRU })
    }
}

export const addBookmarks = (bookmarkType: string, ficusNodes: string[]) => (dispatch: Function, getState: Function) => {
    // Check to see if any bookmarks no longer apply to the current framework listing.
    const frameworkData = getState().selectFrameworkBar
    const bookmarks = processBookmarks(ficusNodes, frameworkData.frameworks)
    dispatch({ type: types.ADD_BOOKMARKS, bookmarkType, bookmarks })
}

export const fetchBookmarks = () => (dispatch: Function) => {
    fetch('/er2_ficus/getBookmarks/')
        .then(ret => ret.json()).then((json) => {
            dispatch(addBookmarks('bookmarksGlobal', json.bookmarksGlobal || []))
        })
}

export const moveBookmark = (srcBookmarkType: String, srcBookmarkNode: String, destBookmarkType: String, destBookmarkNode: String) => (dispatch: Function, getState: Function) => {
    const bookmarks = [...getState().selectBookmarkBar.bookmarksGlobal]
    dispatch({ type: types.MOVE_BOOKMARK, srcBookmarkType, srcBookmarkNode, destBookmarkType, destBookmarkNode })
    const newglobalbookmarks = getState().selectBookmarkBar.bookmarksGlobal
    if (JSON.stringify(bookmarks) !== JSON.stringify(newglobalbookmarks)) {
        updateGlobalBookmarks(newglobalbookmarks)
    }
}

export const removeBookmark = (bookmarkType: string, ficusNode: string) => (dispatch: Function, getState: Function) => {
    dispatch({ type: types.REMOVE_BOOKMARK, bookmarkType, ficusNode })
    updateGlobalBookmarks(getState().selectBookmarkBar.bookmarksGlobal)
}
